module.exports = __webpack_public_path__ + "img/loginbg.a6be7b96.png";